/* =============================================
   YLANG STREET — Shopify Theme JS
   ============================================= */

'use strict';

/* ---- Utilities ---- */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function formatMoney(cents) {
  return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
}

/* ---- Klarna : montant des mensualités ---- */
function updateKlarna(cents, ctx = document) {
  $$('[data-klarna]', ctx).forEach(el => {
    const n = parseInt(el.dataset.installments, 10);
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const text = $('[data-klarna-text]', el);
    if (!text) return;
    text.innerHTML = cents >= min && cents <= max
      ? `Payez en ${n}x <strong>${formatMoney(Math.floor(cents / n))}</strong> sans frais`
      : `Paiement en ${n}x sans frais dès ${formatMoney(min).replace(',00', '')}`;
  });
}

/* ---- Toast notifications ---- */
const toastContainer = document.createElement('div');
toastContainer.className = 'toast-container';
document.body.appendChild(toastContainer);

function showToast(message, type = 'success') {
  const t = document.createElement('div');
  t.className = `toast${type === 'error' ? ' toast--error' : ''}`;
  t.innerHTML = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      ${type === 'error'
        ? '<circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>'
        : '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>'}
    </svg>
    <span>${message}</span>`;
  toastContainer.appendChild(t);
  setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translateX(20px)'; t.style.transition = '300ms'; setTimeout(() => t.remove(), 350); }, 3000);
}

/* ---- Header: scroll state + dropdowns ---- */
function initHeader() {
  const header = $('#header');
  if (!header) return;

  // Solid background on scroll
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Desktop dropdown toggles
  $$('.header__has-dropdown').forEach(item => {
    const btn = item.querySelector('.header__nav-link');
    const menu = item.querySelector('.header__dropdown-menu');
    if (!btn || !menu) return;

    const open = () => { menu.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { menu.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); };

    // Toggle on click (touch-friendly)
    btn.addEventListener('click', e => {
      e.stopPropagation();
      menu.classList.contains('is-open') ? close() : open();
    });

    // Close when focus leaves the item
    item.addEventListener('focusout', e => {
      if (!item.contains(e.relatedTarget)) close();
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', () => {
    $$('.header__dropdown-menu.is-open').forEach(m => {
      m.classList.remove('is-open');
      m.previousElementSibling?.setAttribute('aria-expanded', 'false');
    });
  });
}
initSearchModal();
initMobileMenu();
/* ---- Mobile Menu ---- */
function initMobileMenu() {
  const menu = $('#mobile-menu');
  const openBtn = $('#mobile-menu-open');
  const closeBtn = $('#mobile-menu-close');
  const overlay = menu?.querySelector('.mobile-menu__overlay');
  if (!menu) return;

  function open() {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openBtn?.setAttribute('aria-expanded', 'true');
  }
  function close() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtn?.setAttribute('aria-expanded', 'false');
  }

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);

  // Close on Escape
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}

/* ---- Cart Drawer ---- */
const CartDrawer = {
  el: null,
  init() {
    this.el = $('#cart-drawer');
    const overlay = this.el?.querySelector('.cart-drawer__overlay');
    const closeBtn = $('#cart-drawer-close');
    $$('[data-open-cart]').forEach(b => b.addEventListener('click', () => this.open()));
    closeBtn?.addEventListener('click', () => this.close());
    overlay?.addEventListener('click', () => this.close());
  },
  open() {
    if (!this.el) return;
    this.el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  },
  close() {
    if (!this.el) return;
    this.el.classList.remove('is-open');
    document.body.style.overflow = '';
  },
  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) { console.error('Cart fetch error', e); }
  },
  render(cart) {
    const itemsEl = $('#cart-drawer-items');
    const countEls = $$('[data-cart-count]');
    const totalEl = $('#cart-drawer-total');
    countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    const drawerFooter = $('#cart-drawer-footer');
    if (drawerFooter) updateKlarna(cart.total_price, drawerFooter);
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div class="cart-drawer__empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          <p>Votre panier est vide</p>
          <a href="/collections/all" class="btn btn--primary" onclick="CartDrawer.close()">Découvrir la collection</a>
        </div>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_80x80$1') : '/cdn/shop/files/placeholder.jpg'}" alt="${item.title}" width="80" height="80" loading="lazy">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          ${Object.entries(item.properties || {}).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => `<div class="cart-item__variant">${k} : ${v}</div>`).join('')}
          <div class="cart-item__price">${formatMoney(item.final_price)}</div>
          <div class="cart-item__controls">
            <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuer">−</button>
            <span class="qty-value">${item.quantity}</span>
            <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Augmenter">+</button>
          </div>
        </div>
        <button class="cart-item__remove" data-key="${item.key}" data-qty="0" aria-label="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>`).join('');
      const footerEl = $('#cart-drawer-footer');
      if (footerEl) footerEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    itemsEl.querySelectorAll('[data-qty]').forEach(btn => {
      btn.addEventListener('click', () => this.updateItem(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
  },
  async updateItem(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      this.render(cart);
    } catch (e) { showToast('Erreur lors de la mise à jour', 'error'); }
  }
};

/* ---- Add to Cart ---- */
async function addToCart(variantId, quantity = 1) {
  return postToCart({
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
}

/* Envoie tout le formulaire produit : variante + champs des applis (ex. flocage nom / numéro) */
async function addFormToCart(form) {
  return postToCart({ body: new FormData(form) });
}

async function postToCart(options) {
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', ...options });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || '');
    }
    showToast('Article ajouté au panier !');
    CartDrawer.open();
  } catch (e) { showToast(e.message || 'Impossible d\'ajouter au panier', 'error'); }
}

/* ---- Product Quick-add cards ---- */
function initQuickAdd() {
  $$('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (variantId) addToCart(variantId);
    });
  });
}

/* ---- Product Gallery ---- */
function initProductGallery() {
  const mainImg = $('#product-main-image');
  const thumbs = $$('.product-gallery__thumb');
  if (!mainImg || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = '';
        mainImg.style.opacity = '1';
      }, 150);
    });
  });
}

/* ---- Variant Selection ---- */
function initVariantSelector() {
  const variantBtns = $$('.variant-btn');
  const variantInput = $('#selected-variant');
  const addToCartBtn = $('#add-to-cart-btn');

  if (!variantBtns.length) return;

  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.dataset.group;
      $$(`.variant-btn[data-group="${group}"]`).forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      // Find matching variant
      const selected = {};
      $$('.variant-btn.is-selected').forEach(b => { selected[b.dataset.group] = b.dataset.value; });
      const variants = JSON.parse($('#product-variants-json')?.textContent || '[]');
      const match = variants.find(v => v.options.every((opt, i) => selected[`option${i + 1}`] === opt));
      if (match) {
        if (variantInput) variantInput.value = match.id;
        if (addToCartBtn) addToCartBtn.disabled = !match.available;
        const priceEl = $('#product-price');
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        const productInfo = $('.product-info');
        if (productInfo) updateKlarna(match.price, productInfo);
      }
    });
  });

}

/* ---- Product form (ajout au panier sans quitter la page) ---- */
function initProductForm() {
  const form = $('#product-form');
  if (!form) return;
  form.addEventListener('submit', e => {
    // Une appli (ex. Teeinblue) qui gère elle-même l'ajout au panier a déjà annulé l'envoi
    if (e.defaultPrevented) return;
    e.preventDefault();
    const flocage = getFlocage(form);
    if (flocage) addFlocageToCart(form, flocage);
    else addFormToCart(form);
  });
}

/* ---- Flocage nom / numéro ---- */
function initFlocage() {
  const box = $('[data-flocage]');
  if (!box) return;
  const toggle = $('[data-flocage-toggle]', box);
  const fields = $('[data-flocage-fields]', box);
  const inputs = $$('input[name^="properties"]', fields);
  const expressPay = $('.buy-now-form');

  toggle.addEventListener('change', () => {
    fields.hidden = !toggle.checked;
    // Champs désactivés = non envoyés avec l'article
    inputs.forEach(i => { i.disabled = !toggle.checked; i.required = toggle.checked; });
    // Le paiement express ne peut pas ajouter le supplément : on le masque pendant le flocage
    if (expressPay) expressPay.hidden = toggle.checked;
    if (toggle.checked) inputs[0].focus();
  });

  inputs.forEach(i => i.addEventListener('input', () => {
    const pos = i.selectionStart;
    i.value = i.inputMode === 'numeric' ? i.value.replace(/\D/g, '') : i.value.toUpperCase();
    i.setSelectionRange(pos, pos);
  }));
}

function getFlocage(form) {
  const box = $('[data-flocage]', form);
  if (!box || !$('[data-flocage-toggle]', box).checked) return null;
  return { feeVariant: box.dataset.feeVariant };
}

/* Ajoute le maillot (avec nom / numéro) + le produit « Flocage » en une seule requête */
async function addFlocageToCart(form, flocage) {
  if (!flocage.feeVariant) return addFormToCart(form);
  const data = new FormData(form);
  const item = { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity') || '1', 10), properties: {} };
  for (const [key, value] of data.entries()) {
    const m = key.match(/^properties\[(.+)\]$/);
    if (m && value) item.properties[m[1]] = value;
  }
  const title = $('.product-info__title')?.textContent.trim() || '';
  const fee = {
    id: parseInt(flocage.feeVariant, 10),
    quantity: item.quantity,
    properties: { Maillot: title, Nom: item.properties.Nom || '', 'Numéro': item.properties['Numéro'] || '' }
  };
  return postToCart({
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [item, fee] })
  });
}

/* ---- Collection filter pills ---- */
function initCollectionFilters() {
  const pills = $$('[data-filter-tag]');
  if (!pills.length) return;

  pills.forEach(pill => {
    pill.addEventListener('click', () => {
      pills.forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const tag = pill.dataset.filterTag;
      const products = $$('[data-product-tags]');
      products.forEach(card => {
        const tags = (card.dataset.productTags || '').split(',');
        card.style.display = tag === 'all' || tags.includes(tag) ? '' : 'none';
      });
    });
  });
}
/* ---- Search Modal ---- */
function initSearchModal() {
  const modal = $('#search-modal');
  const input = $('#search-modal-input');
  const results = $('#search-modal-results');
  const openBtn = $('#search-open');
  const closeBtn = $('#search-modal-close');
  const overlay = $('#search-modal-overlay');
  if (!modal) return;

  let debounceTimer;

  function open() {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openBtn?.setAttribute('aria-expanded', 'true');
    setTimeout(() => input?.focus(), 50);
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtn?.setAttribute('aria-expanded', 'false');
    if (input) input.value = '';
    if (results) results.innerHTML = '';
  }

  openBtn?.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  input?.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    debounceTimer = setTimeout(() => fetchSuggestions(q), 280);
  });

  input?.addEventListener('keydown', e => {
    if (e.key === 'Enter' && input.value.trim()) {
      window.location = `/search?q=${encodeURIComponent(input.value.trim())}&type=product`;
      close();
    }
  });

  async function fetchSuggestions(q) {
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=5&resources[options][fields]=title,product_type,variants.title`;
      const res = await fetch(url);
      const data = await res.json();
      renderResults(q, data.resources?.results || {});
    } catch (e) {
      results.innerHTML = '';
    }
  }

  function renderResults(q, res) {
    const products = res.products || [];
    const collections = res.collections || [];
    if (!products.length && !collections.length) {
      results.innerHTML = `<p style="padding:1.25rem;opacity:0.5;font-size:0.9rem">Aucun résultat pour « ${q} »</p>`;
      return;
    }
    let html = '';
    if (products.length) {
      html += `<p class="search-modal__section-title">Produits</p>`;
      products.forEach(p => {
        const price = p.price ? formatMoney(p.price * 100) : '';
        const img = p.image ? `<img class="search-modal__item-img" src="${p.image}" alt="${p.title}" loading="lazy">` : `<div class="search-modal__item-img-placeholder"></div>`;
        html += `<a href="${p.url}" class="search-modal__item">${img}<div class="search-modal__item-info"><div class="search-modal__item-title">${p.title}</div>${price ? `<div class="search-modal__item-price">${price}</div>` : ''}</div></a>`;
      });
    }
    if (collections.length) {
      html += `<p class="search-modal__section-title">Collections</p>`;
      collections.forEach(c => {
        const img = c.image ? `<img class="search-modal__item-img" src="${c.image}" alt="${c.title}" loading="lazy">` : `<div class="search-modal__item-img-placeholder"></div>`;
        html += `<a href="${c.url}" class="search-modal__item">${img}<div class="search-modal__item-info"><div class="search-modal__item-title">${c.title}</div></div></a>`;
      });
    }
    html += `<div class="search-modal__footer"><a href="/search?q=${encodeURIComponent(q)}&type=product">Voir tous les résultats pour « ${q} » →</a></div>`;
    results.innerHTML = html;
  }
}

/* ---- Collection search ---- */
function initCollectionSearch() {
  const searchInput = $('#collection-search');
  if (!searchInput) return;

  searchInput.addEventListener('input', () => {
    const q = searchInput.value.toLowerCase().trim();
    $$('[data-product-title]').forEach(card => {
      const title = (card.dataset.productTitle || '').toLowerCase();
      card.style.display = !q || title.includes(q) ? '' : 'none';
    });
  });
}

/* ---- Scroll animations ---- */
function initScrollAnimations() {
  const elements = $$('[data-animate]');
  if (!elements.length) return;

  // In Shopify theme editor, show everything immediately
  if (window.Shopify && window.Shopify.designMode) {
    elements.forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

  elements.forEach(el => observer.observe(el));
}

// Listen for Shopify editor events to re-init animations when sections change
document.addEventListener('shopify:section:load', () => {
  $$('[data-animate]').forEach(el => el.classList.add('is-visible'));
});

/* ---- Contact form ---- */
function initContactForm() {
  const form = $('#contact-form');
  if (!form) return;
  form.addEventListener('submit', e => {
    // Shopify handles form submission; we just intercept for UX
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Envoi...'; }
  });
}

/* ---- Newsletter form ---- */
function initNewsletterForm() {
  const form = $('#newsletter-form');
  if (!form) return;
  form.addEventListener('submit', e => {
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.textContent = 'Inscrit !';
  });
}

/* ---- Init ---- */
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileMenu();
  CartDrawer.init();
  CartDrawer.refresh();
  initQuickAdd();
  initProductGallery();
  initVariantSelector();
  initProductForm();
  initFlocage();
  initCollectionFilters();
  initCollectionSearch();
  initScrollAnimations();
  initContactForm();
  initNewsletterForm();
});
